import {axios, HOST, config} from './settiing';

export default {
  getMapMonitoringInfo() {
    return axios.get(`${HOST}/manage/vehicleLocation` , config);
  },
  getMacaronMapMonitoringInfo() {
    return axios.get(`${HOST}/manage/macaronGreen/vehicleLocation` , config);
  },
  getDailyReportsData(start, end, keyword) {
    return axios.get(`${HOST}/manage/reports?startDate=${start}&endDate=${end}&keyword=${keyword}`, config);
  },
  getStatisticData(start, end) {
    return axios.get(`${HOST}/manage/statistics?startDate=${start}&endDate=${end}`, config);
  },
  getPurposeReportsData(start, end, type) {
    return axios.get(`${HOST}/manage/reports/purpose?startDate=${start}&endDate=${end}&type=${type}`, config);
  },
  getCustomerReportsData(start, end, type) {
    return axios.get(`${HOST}/manage/reports/customer?startDate=${start}&endDate=${end}&type=${type}`, config);
  },
  getIncomeReportsData(start, end, keyword) {
    return axios.get(`${HOST}/manage/reports/income?startDate=${start}&endDate=${end}&keyword=${keyword}`, config);
  },
  getFeeReportsData(start, end, type) {
    return axios.get(`${HOST}/manage/reports/fee?startDate=${start}&endDate=${end}&type=${type}`, config);
  }
}